import * as React from 'react';
import EntranceHeader from '../../../../components/EntranceHeader';
import SideBar from '../../../../components/SideBar';
import {Modal }from 'react-bootstrap';

class DashboardDesign extends React.Component<any, any> {
    constructor(props:any, context:any) {
        super(props, context);
    
        this.handleHide = this.handleHide.bind(this);
    
        this.state = {
          show: false
        };
      }
    
      handleHide() {
        this.setState({ show: false });
      }
      
  render() {
    return (
        
      <div className={`app-body full-sidebar`}>
        <EntranceHeader />
        <SideBar
          showHeader={() => console.log('sdf')}
          detectMobileEvent={() => console.log('sdf')}
          topMenus={[]}
          bottomMenus={[]}
          hideNavBar={false}
          history={this.props.history}
          hideNotification={() => console.log('sdf')}
        />
        <main role="content-body">
          <section role="dashboard-wrapper">
            <div className="bredcrumb"><a href="#"> Live Classes</a> / Live and Upcoming Classes</div>
           {/*
           // recorded video pages
           <div className="row">
               <div className="col-md-12">
               <div className="videoplayer">
                   <video></video>
                </div>  
                <div className="video-title">Introduction to Python</div>  
                <div className="video-narration">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>
                </div>  
               </div>
              
           </div> */}
            
           
            
            //view all page with form filter
            
            <div className="date-selection">
                <div className="center">
                    <span className="glyphicon glyphicon-menu-left"></span>
                    <ul>
                        <li className="selected">Friday 27 March</li>
                        <li>Tuesday 31 March</li>
                        <li>Friday 3 April</li>
                        <li>Tuesday 7 April</li>
                        <li>Friday 10 April</li>
                    </ul>
                    <span className="glyphicon glyphicon-menu-right"></span>
                </div>  
            </div>
            <div className="row center mb-20">
            <div className="col-md-4 field-list">
            <div className="form-group">
                <label htmlFor="country">Course Name</label>
                <div className="select-wrap">
                    <select className="form-control">
                    <option value="">Introduction To Computer Science For AI</option>
                    <option value="">Mathematics for AI</option>

                    </select>
                </div>
                <span className="error-msg"></span>
            </div>
            </div>
            <div className="col-md-4 field-list">
            <div className="form-group">
                <label htmlFor="country">Module Name</label>
                <div className="select-wrap">
                    <select className="form-control">
                    <option value="">Introduction to the Course</option>
                    <option value="">Basics of Computer Systems</option>
                    <option value="">Python Programming</option>
                    <option value="">Data Structures and Algorithms Analysis</option>
                    <option value="">Database</option>
                    <option value="">Building Applications</option>
                    </select>
                </div>
            </div>
            </div>
            <div className="col-md-4 field-list">
            <div className="form-group">
                <label htmlFor="country">Instructor Name</label>
                <div className="select-wrap">
                    <select className="form-control">
                    <option value="">Anish Shrestha</option>
                    <option value="">Manish Raj</option>
                    <option value="">Thomas Watson</option>
                    <option value="">Andrew Yan-Tak Ng</option>
                    </select>
                </div>
            </div>
            </div>
            </div>
            <div className="classes-group container-fluid">
                <div className="section__title">Friday 27 March</div>
                <ul className="classes-list  mb-20">
                    <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--live">live now</div>
                                    <div className="datetime"></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                            <a href="#" className="btn btn-md btn-blue pull-right">JOIN CLASS</a>
                            </div>
                        </div>
                    </li>
                    <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--scheduled ">schedule</div>
                                    <div className="datetime">Today, 2:45pm</div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                                    <button className="btn btn-md btn-blue-stroke pull-right" onClick={() => this.setState({ show: true })}>COUNT ME IN</button>
                                    <div className="class-card__remaining">
                                        <div className="class-card__remaining--time">2 hrs</div>
                                        <div className="class-card__remaining--label">Till start</div>
                                    </div>
                            </div>
                        </div>
                    </li>
                </ul>
                </div>  

                <div className="classes-group container-fluid">
                <div className="section__title">Tuesday 31 March</div>
                <ul className="classes-list mb-20">
                <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--scheduled ">schedule</div>
                                    <div className="datetime">Today, 2:45pm</div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                                    <a href="#" className="btn btn-md btn-blue-stroke pull-right" onClick={() => this.setState({ show: true })}>COUNT ME IN</a>
                                    <div className="class-card__remaining">
                                        <div className="class-card__remaining--time">2 hrs</div>
                                        <div className="class-card__remaining--label">Till start</div>
                                    </div>
                            </div>
                        </div>
                    </li>
                    <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--scheduled ">schedule</div>
                                    <div className="datetime">Today, 2:45pm</div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                                    <a href="#" className="btn btn-md btn-blue-stroke pull-right" onClick={() => this.setState({ show: true })}>COUNT ME IN</a>
                                    <div className="class-card__remaining">
                                        <div className="class-card__remaining--time">2 hrs</div>
                                        <div className="class-card__remaining--label">Till start</div>
                                    </div>
                            </div>
                        </div>
                    </li>
                    <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--scheduled ">schedule</div>
                                    <div className="datetime">Today, 2:45pm</div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                                    <a href="#" className="btn btn-md btn-blue-stroke pull-right">COUNT ME IN</a>
                                    <div className="class-card__remaining">
                                        <div className="class-card__remaining--time">2 hrs</div>
                                        <div className="class-card__remaining--label">Till start</div>
                                    </div>
                            </div>
                        </div>
                    </li>
                    <li className="class-card">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="spacing">
                                    <div className="btn class-card__label--scheduled ">schedule</div>
                                    <div className="datetime">Today, 2:45pm</div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="class-card__name">Introduction to Python</div>
                                <div>
                                    <ul className="class-card__more">
                                        <li>Machine Learning</li>
                                        <li>Module Name</li>
                                    </ul>
                                </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            </div>
                            <div className="col-md-3">
                                    <a href="#" className="btn btn-md btn-blue-stroke pull-right">COUNT ME IN</a>
                                    <div className="class-card__remaining">
                                        <div className="class-card__remaining--time">2 hrs</div>
                                        <div className="class-card__remaining--label">Till start</div>
                                    </div>
                            </div>
                        </div>
                    </li>
                </ul>
                </div>                   


              {/*  
             // -------------------FIRST section od live and upcoming classes ---------------------------
            <div className="row">
                <div className="col-md-12">
                    <div className="section_title">Live and Upcoming Classes</div>
                    <div className="redirection">
                        <a href="#" className="">View Full Schedule <span className="glyphicon glyphicon-menu-right"></span></a>
                    </div>
                </div>
                </div>
                <div className="row mb-40">
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15">
                                <div className="class-card__label--live btn">live now</div>
                                <div className="datetime"> Today, 2:45pm</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div>
                                <a href="#" className="btn btn-md btn-blue">JOIN CLASS</a>
                            <div className="class-card__remaining">
                                    <div className="class-card__remaining--time"></div>
                                    <div className="class-card__remaining--label"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15"> 
                                <div className="class-card__label--scheduled btn">scheduled</div>
                                <div className="datetime"> Today, 2:45pm</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div><a href="#" className="btn btn-md btn-blue-stroke">COUNT ME IN</a>
                            <div className="class-card__remaining">
                            <div className="class-card__remaining--time">2 hrs</div>
                                    <div className="class-card__remaining--label">Till start</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15">
                                <div className="class-card__label--scheduled btn">scheduled</div>
                                <div className="datetime">March 30, 2020 8:45am</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div>
                                <a href="#" className="btn btn-md btn-blue-stroke">COUNT ME IN</a>
                                <div className="class-card__remaining">
                                    <div className="class-card__remaining--time">4 days 2 hrs</div>
                                    <div className="class-card__remaining--label">Till start</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
              // -------------------second  section of Recorded classes ---------------------------
                <div className="row">
                <div className="col-md-12">
                    <div className="section_title">Recorded Classes</div>
                    <div className="redirection">
                        <a href="#" className="">All classes <span className="glyphicon glyphicon-menu-right"></span></a>
                    </div>
                </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15">
                                <div className="class-card__label--recorded btn">recorded</div>
                                <div className="datetime"> Recorded on March 26, 2020</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div>
                                <a href="#" className="btn btn-md btn-blue">VIEW RECORDING</a>
                            <div className="class-card__remaining">
                                    <div className="class-card__remaining--time"></div>
                                    <div className="class-card__remaining--label"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15"> 
                                <div className="class-card__label--recorded btn">recorded</div>
                                <div className="datetime"> Recorded on March 26, 2020</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div><a href="#" className="btn btn-md btn-blue">VIEW RECORDING</a>
                            <div className="class-card__remaining">
                                    <div className="class-card__remaining--time"></div>
                                    <div className="class-card__remaining--label"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-4">
                        <div className="class-card">
                            <div className="mb-15">
                                <div className="class-card__label--recorded btn">recorded</div>
                                <div className="datetime">Recorded on March 26, 2020</div>
                            </div>
                                    <div className="class-card__name">Introduction to Python</div>
                                    <div >
                                        <ul className="class-card__more">
                                            <li>Machine Learning</li>
                                            <li>Module Name</li>
                                        </ul>
                                 </div>
                                <div className="class-card__instructor">Instructor: Instructor Name</div>
                            <div>
                                <a href="#" className="btn btn-md btn-blue">VIEW RECORDING</a>
                                <div className="class-card__remaining">
                                    <div className="class-card__remaining--time"></div>
                                    <div className="class-card__remaining--label"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                       
                </div>


            */}
              



          </section>
          {/* ---------------------- New student display with call in action to program------------------------------ */}
          <section role="dashboard-wrapper">
                       {/* <div className="welcome-info mb-20">
              <div className="row">
                <div className="col-md-1"> <img src="/images/dashboard/greet-icon.png"></img></div>
                <div className="col-md-11">
                  <p className="greeting"> Welcome User,</p>
                  <p className="information">You have completed 20% of the program this week. Continue learning and improve your result.</p>
                </div>
              </div>
            </div> */}   


            {/* <div className="middle">
              <div><img className="mb-40" src="/images/dashboard/new-student.svg"/></div>
              <div><h4 className="text-blue mb-20">Start building your dashboard!</h4>
                <p className="text-gray mb-40">Before we can create any charts, we’ll first need to get some data in here!</p>
                <a href="/student" className="btn btn-md btn-blue">Let's start learning</a></div>
            </div> */}

          </section>
          <Modal
          bsSize="small"
          show={this.state.show}
          onHide={this.handleHide}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Body>
            <div className="popup">
                <div className="mb-15 flex-div">
                    <div className="class-card__label--scheduled btn">scheduled</div>
                    <div className="datetime"> Today, 2:45pm</div>
                </div>
                <div className="class-card__name">Introduction to Python</div>
                <div >
                    <ul className="class-card__more">
                        <li>Machine Learning</li>
                        <li>Module Name</li>
                    </ul>
                </div>
                <div className="class-card__instructor">Instructor: Instructor Name</div>
                <div className="flex-div">
                    <a href="#" className="btn btn-md btn-blue-stroke">COUNT ME IN</a>
                </div>
                <div className="calender"><a href="#">Add to Google Calendar</a></div>
            </div>

          </Modal.Body>
        </Modal>

        </main>
      </div>

    );
  }
}
export default DashboardDesign;
